import { GoogleAppRow } from '../components/GoogleAppRow';
import type { AppRow } from '../type/AppRow';

export const googleAppRow: AppRow = {
  key: 'google',
  name: 'Google',
  AppComponent: GoogleAppRow,
};
